/*
 * common.js — テーマ共通の UI 挙動（vanilla JS）
 * jQuery 依存を全廃（旧 jQuery 1.12.4 + common.js の jQuery 版から移植・挙動は 1:1 維持）。
 */
(function () {
  'use strict';

  /* ---- slide ヘルパ（jQuery slideToggle 相当・高さアニメーション） ---- */
  function slideUp(target, duration) {
    duration = duration || 300;
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight; // reflow
    target.style.overflow = 'hidden';
    target.style.height = '0';
    target.style.paddingTop = '0';
    target.style.paddingBottom = '0';
    target.style.marginTop = '0';
    target.style.marginBottom = '0';
    window.setTimeout(function () {
      target.style.display = 'none';
      ['height', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom',
        'overflow', 'transition-duration', 'transition-property', 'box-sizing'
      ].forEach(function (p) { target.style.removeProperty(p); });
    }, duration);
  }

  function slideDown(target, duration) {
    duration = duration || 300;
    target.style.removeProperty('display');
    var display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    var height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = '0';
    target.style.paddingTop = '0';
    target.style.paddingBottom = '0';
    target.style.marginTop = '0';
    target.style.marginBottom = '0';
    target.offsetHeight; // reflow
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    ['padding-top', 'padding-bottom', 'margin-top', 'margin-bottom'].forEach(function (p) {
      target.style.removeProperty(p);
    });
    window.setTimeout(function () {
      ['height', 'overflow', 'transition-duration', 'transition-property', 'box-sizing'
      ].forEach(function (p) { target.style.removeProperty(p); });
    }, duration);
  }

  function isHidden(el) {
    return window.getComputedStyle(el).display === 'none';
  }

  function slideToggle(target, duration) {
    if (isHidden(target)) {
      slideDown(target, duration);
    } else {
      slideUp(target, duration);
    }
  }

  /* 次の兄弟要素を返す（任意で selector 一致を要求 = jQuery .next(selector) 相当） */
  function next(el, selector) {
    var sib = el.nextElementSibling;
    if (!sib) return null;
    if (selector && !sib.matches(selector)) return null;
    return sib;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    /* ---- pockeshun-jewelry: スクロールで戻るボタン表示 ---- */
    if (document.URL.indexOf('pockeshun-jewelry') !== -1) {
      var previewtop = document.getElementById('previewBackBtn');
      var description = document.querySelector('.product__description');
      if (previewtop && description) {
        window.addEventListener('scroll', function () {
          var winScroll = window.pageYOffset;
          var fixTop = description.getBoundingClientRect().top + window.pageYOffset;
          var winHeight = window.innerHeight;
          if (winScroll > 500 && winScroll + winHeight < fixTop) {
            previewtop.classList.add('active');
          } else {
            previewtop.classList.remove('active');
          }
        });
        previewtop.addEventListener('click', function (e) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    }

    /* ---- アコーディオン（.accordion > dt / .faq-accordion > dt） ---- */
    ['.accordion > dt', '.faq-accordion > dt'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (dt) {
        dt.addEventListener('click', function () {
          dt.classList.toggle('active');
          var dd = next(dt, 'dd');
          if (dd) slideToggle(dd);
        });
      });
    });

    /* ---- ドロワー ---- */
    function closeDrawer(headerId, drawerSelector) {
      var header = document.getElementById(headerId);
      if (!header || !header.classList.contains('active')) return;
      header.classList.remove('active');
      var drawer = next(header, drawerSelector || '.custom-sub-drower');
      if (drawer) {
        drawer.style.display = 'none';
        drawer.classList.remove('active');
      }
    }

    var kindBtn = document.getElementById('種類で探す');
    if (kindBtn) {
      kindBtn.addEventListener('click', function (e) {
        e.preventDefault();
        kindBtn.classList.toggle('active');
        var ul = next(kindBtn, 'ul');
        if (ul) slideToggle(ul);
      });
    }

    var looseHeader = document.getElementById('custom-sub__header--loose');
    if (looseHeader) {
      looseHeader.addEventListener('click', function (e) {
        e.preventDefault();
        looseHeader.classList.toggle('active');
        var drawer = next(looseHeader, '#custom-sub-drower--loose');
        if (drawer) {
          slideToggle(drawer);
          drawer.classList.toggle('active');
        }
        closeDrawer('custom-sub__header--jewelry');
      });
    }

    var jewelryHeader = document.getElementById('custom-sub__header--jewelry');
    if (jewelryHeader) {
      jewelryHeader.addEventListener('click', function (e) {
        e.preventDefault();
        jewelryHeader.classList.toggle('active');
        var drawer = next(jewelryHeader, '#custom-sub-drower--jewelry');
        if (drawer) {
          slideToggle(drawer);
          drawer.classList.toggle('active');
        }
        closeDrawer('custom-sub__header--loose');
      });
    }

    document.querySelectorAll('.menu-drawer-container').forEach(function (container) {
      container.addEventListener('click', function () {
        closeDrawer('custom-sub__header--loose');
        closeDrawer('custom-sub__header--jewelry');
      });
    });

    /* ---- ガイドページ アコーディオン（768px 以上は常時開く） ---- */
    var guideHeadings = document.querySelectorAll('.guide_wrap h2');
    if (guideHeadings.length) {
      guideHeadings.forEach(function (h2) {
        h2.addEventListener('click', function () {
          if (window.matchMedia('(min-width: 767px)').matches) return;
          h2.classList.toggle('active');
          var div = next(h2, 'div');
          if (div) slideToggle(div);
        });
      });
      var guideMql = window.matchMedia('(min-width: 767px)');
      var guideListener = function (event) {
        if (event.matches) {
          guideHeadings.forEach(function (h2) {
            h2.classList.remove('active');
            var div = next(h2, 'div');
            if (div) div.style.display = '';
          });
        }
      };
      guideMql.addEventListener('change', guideListener);
      guideListener(guideMql);
    }

    /* ---- custom-sub-drower の位置・高さ調整 ---- */
    var subDrowers = document.querySelectorAll('.custom-sub-drower');
    if (subDrowers.length) {
      var applyDrowerLayout = function () {
        var bar = document.querySelector('.utility-bar');
        var header = document.querySelector('sticky-header');
        var heightBar = bar ? bar.offsetHeight : 0;
        var heightHeader = header ? header.offsetHeight : 0;
        var windowHeight = window.innerHeight;
        var sectionHeader = document.querySelector('.section-header');
        var hidden = sectionHeader && sectionHeader.classList.contains('shopify-section-header-hidden');
        subDrowers.forEach(function (el) {
          if (hidden) {
            el.style.top = '0px';
            el.style.height = windowHeight + 'px';
          } else if (window.pageYOffset > heightBar) {
            el.style.top = heightHeader + 'px';
            el.style.height = (windowHeight - heightHeader) + 'px';
          } else {
            el.style.top = (heightHeader + heightBar) + 'px';
            el.style.height = (windowHeight - (heightHeader + heightBar)) + 'px';
          }
        });
      };
      applyDrowerLayout();
      window.addEventListener('scroll', applyDrowerLayout);
    }

    /* ---- カートページ: 同意チェックで購入ボタン活性 ---- */
    var cartAgree = document.getElementById('cart-checkbox-agree');
    if (cartAgree) {
      cartAgree.addEventListener('click', function () {
        document.querySelectorAll('.malin-cartBtn').forEach(function (btn) {
          btn.classList.toggle('active');
        });
      });
    }
  });

  /* ---- pockeshun-jewelry: カスタマイズ金額をカートボタン上に複製表示 ---- */
  /* （旧来から vanilla・MutationObserver。挙動維持） */
  if (location.pathname.indexOf('pockeshun-jewelry') !== -1) {
    window.addEventListener('DOMContentLoaded', function () {
      var target = document.getElementById('pockeshun-price');
      var result = document.getElementById('pockeshun-price-result');
      if (!target || !result) return;
      var observer = new MutationObserver(function () {
        result.innerHTML = '現在の合計金額：<span>' + target.textContent + '</span>';
      });
      observer.observe(target, { childList: true });
    });
  }
})();
